// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var URLUtils$SmartcutsMacros = require("../../bs-utils/src/URLUtils.bs.js");
var AppConfig$SmartcutsMacros = require("../../../src/common/AppConfig.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var LoginSmartcut$SmartcutsMacros = require("./LoginSmartcut.bs.js");
var OAuthProvider$SmartcutsMacros = require("./OAuthProvider.bs.js");
var PlaybackValues$SmartcutsMacros = require("./PlaybackValues.bs.js");
var UserCredential$SmartcutsMacros = require("./UserCredential.bs.js");
var GoogleSheetHelpers$SmartcutsMacros = require("./GoogleSheetHelpers.bs.js");
var PlaybackParamValue$SmartcutsMacros = require("./PlaybackParamValue.bs.js");
var RadioOrSelectOption$SmartcutsMacros = require("./commands/shared/RadioOrSelectOption.bs.js");
var WithElementGroupsCommand$SmartcutsMacros = require("./commands/WithElementGroupsCommand.bs.js");
var GoogleApis__Sheets__Schema$SmartcutsMacros = require("../../bs-googleapis/apis/sheets/GoogleApis__Sheets__Schema.bs.js");
var ExtensionMessaging__FromTab$SmartcutsMacros = require("./ExtensionMessaging__FromTab.bs.js");
var ContentScript__StateMachine__Shared$SmartcutsMacros = require("./ContentScript/StateMachine/ContentScript__StateMachine__Shared.bs.js");

function setDataValidationRule(dataValidationRule, columnIndex, param) {
  var arg = OptionUtils$SmartcutsMacros.withDefault([], param.values);
  return {
          values: Curry._1((function (param) {
                      var func = function (param$1, param$2, param$3) {
                        return ArrayUtils$SmartcutsMacros.setAtIndexAndFillGap(param, param$1, param$2, param$3);
                      };
                      return function (param) {
                        var func$1 = Curry._1(func, param);
                        return function (param) {
                          return Curry._2(func$1, param, arg);
                        };
                      };
                    })(columnIndex)(GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(Caml_option.some(dataValidationRule), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)), GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))
        };
}

var Row_emptyRow = {
  values: undefined
};

var Row = {
  emptyRow: Row_emptyRow,
  setDataValidationRule: setDataValidationRule
};

function makeWorksheet(headers, rows) {
  return GoogleApis__Sheets__Schema$SmartcutsMacros.Sheet.make(undefined, undefined, undefined, undefined, undefined, [{
                columnMetadata: undefined,
                rowData: Belt_Array.concat([{
                        values: Belt_Array.map(headers, (function (header) {
                                return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.stringValue(header), undefined);
                              }))
                      }], rows),
                rowMetadata: undefined,
                startColumn: 0,
                startRow: 0
              }], undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function askBgToCreateSheet(authToken, spreadsheetName, worksheet) {
  return Curry._2(ExtensionMessaging__FromTab$SmartcutsMacros.CreateGoogleSheet.encodeAndSendMessageToExtensionId, AppConfig$SmartcutsMacros.extensionId, /* CreateSpreadsheet */{
              _0: {
                title: spreadsheetName,
                sheets: [worksheet],
                authToken: authToken
              }
            });
}

function askExtensionToCreateAnySpreadsheetsForInstall(commandLog, smartcutName) {
  var spreadsheetNameAndColNamesAndCmdIndexBySheetId = Belt_List.reduceWithIndex(commandLog, undefined, (function (spreadsheetNameAndColNamesAndCmdIndexBySheetId, param, commandIndex) {
          var command = param.command;
          var arg = OptionUtils$SmartcutsMacros.map(param.contextGlobal.title, (function (titleWithGoogleSuffix) {
                  return titleWithGoogleSuffix.replace(/ - Google Sheets$/, "");
                }));
          var spreadsheetName = (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })("Sheet for Smartcut: " + smartcutName);
          if (typeof command === "number") {
            return spreadsheetNameAndColNamesAndCmdIndexBySheetId;
          }
          if (command.TAG !== /* GoogleSheetsCommand */33) {
            return spreadsheetNameAndColNamesAndCmdIndexBySheetId;
          }
          var match = command._0;
          var colNames = match.colNames;
          return Belt_MapString.update(spreadsheetNameAndColNamesAndCmdIndexBySheetId, match.spreadsheetId, (function (maybeLastSheetNameAndColNames) {
                        if (maybeLastSheetNameAndColNames !== undefined) {
                          return [
                                  spreadsheetName,
                                  Belt_Array.reduce(colNames, maybeLastSheetNameAndColNames[1], (function (newColNames, colName) {
                                          if ($$Array.mem(colName, newColNames)) {
                                            return newColNames;
                                          } else {
                                            return $$Array.append(newColNames, [colName]);
                                          }
                                        })),
                                  maybeLastSheetNameAndColNames[2]
                                ];
                        } else {
                          return [
                                  spreadsheetName,
                                  colNames,
                                  commandIndex - 1 | 0
                                ];
                        }
                      }));
        }));
  if (Belt_MapString.isEmpty(spreadsheetNameAndColNamesAndCmdIndexBySheetId)) {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: /* DoesNotInvolveGoogleSheets */1
              });
  } else {
    return ContentScript__StateMachine__Shared$SmartcutsMacros.askBgScriptToFetchAuthToken(AppConfig$SmartcutsMacros.extensionId, undefined).then(function (maybeAuthToken) {
                  if (maybeAuthToken !== undefined) {
                    return Promise.resolve(maybeAuthToken);
                  } else {
                    return Curry._2(ExtensionMessaging__FromTab$SmartcutsMacros.InitGoogleAuthFlow.encodeAndSendMessageToExtensionId, AppConfig$SmartcutsMacros.extensionId, /* InitGoogleAuthFlow */{
                                  _0: /* BeforeCreateSheetOnInstallSmartcut */4
                                }).then(function (result) {
                                if (result.TAG === /* Ok */0) {
                                  var authToken = result._0;
                                  if (authToken) {
                                    return Promise.resolve(authToken._0);
                                  } else {
                                    return Promise.resolve(undefined);
                                  }
                                }
                                console.error(result._0);
                                return Promise.resolve(undefined);
                              });
                  }
                }).then(function (maybeAuthToken) {
                if (maybeAuthToken === undefined) {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: /* DidNotCreateGoogleSheetBecauseOAuthNotGranted */2
                            });
                }
                var promises = Belt_Array.map(Belt_MapString.valuesToArray(spreadsheetNameAndColNamesAndCmdIndexBySheetId), (function (param) {
                        var firstCommandIndex = param[2];
                        return askBgToCreateSheet(maybeAuthToken, param[0], makeWorksheet(param[1], [])).then(function (result) {
                                    return Promise.resolve([
                                                result,
                                                firstCommandIndex
                                              ]);
                                  });
                      }));
                return Promise.all(promises).then(function (results) {
                            var result = Belt_Array.reduce(results, {
                                  TAG: /* Ok */0,
                                  _0: undefined
                                }, (function (resultSheetUrlByFirstCommandIndex, param) {
                                    var resultFromExtension = param[0];
                                    if (resultSheetUrlByFirstCommandIndex.TAG !== /* Ok */0) {
                                      return resultSheetUrlByFirstCommandIndex;
                                    }
                                    if (resultFromExtension.TAG !== /* Ok */0) {
                                      return {
                                              TAG: /* Error */1,
                                              _0: resultFromExtension._0
                                            };
                                    }
                                    var match = resultFromExtension._0;
                                    if (typeof match === "number") {
                                      switch (match) {
                                        case /* DidNotCreateSpreadsheet */0 :
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: "Smartcuts ran into an issue creating the Google Sheet involved in this automation"
                                                  };
                                        case /* DidNotCreateSpreadsheetBecauseUnauthenticated */1 :
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: "Smartcuts doesn't have access to create the Google Sheet involved in this automation"
                                                  };
                                        case /* DidNotCreateSpreadsheetBecauseGapiNotLoaded */2 :
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: "Reload your extension or restart Chrome. Smartcuts had issues accessing Google APIs."
                                                  };
                                        
                                      }
                                    } else {
                                      var sheetUrl = match._0.spreadsheetUrl;
                                      if (sheetUrl !== undefined) {
                                        return {
                                                TAG: /* Ok */0,
                                                _0: Belt_MapInt.set(resultSheetUrlByFirstCommandIndex._0, param[1], sheetUrl)
                                              };
                                      } else {
                                        return {
                                                TAG: /* Error */1,
                                                _0: "Smartcuts ran into an issue creating the Google Sheet involved in this automation"
                                              };
                                      }
                                    }
                                  }));
                            var tmp;
                            tmp = result.TAG === /* Ok */0 ? ({
                                  TAG: /* Ok */0,
                                  _0: /* DidCreateSheetsByFirstCommandIndex */{
                                    _0: result._0
                                  }
                                }) : ({
                                  TAG: /* Error */1,
                                  _0: result._0
                                });
                            return Promise.resolve(tmp);
                          });
              });
  }
}

function textForRadioOrSelectOption(opt) {
  return RadioOrSelectOption$SmartcutsMacros.valueAndTextGet(opt)[1];
}

function header(column) {
  switch (column.TAG | 0) {
    case /* OpenWebsiteURL */0 :
        return "Website URL";
    case /* AddTextOption */1 :
        return column.addTextInputParam.playbackFormLabel;
    case /* InnerTextOption */2 :
        return column.innerTextParam.playbackFormLabel;
    case /* CheckboxOption */3 :
        return column.checkboxParam.playbackFormLabel;
    case /* SelectInputOption */4 :
        return column.selectInputParam.playbackFormLabel;
    case /* RadioInputOption */5 :
        return column.radioInputParam.playbackFormLabel;
    case /* DownloadOption */6 :
        return column.downloadParam.playbackFormLabel;
    case /* GoogleSheetsOption */7 :
        var match = column.googleSheetsParam;
        if (match.TAG === /* UpdateCellParam */0) {
          return match._0.playbackFormLabel;
        } else {
          return match._0.playbackFormLabel;
        }
    case /* LoopOption */8 :
        return "-";
    case /* UploadOption */9 :
        return column.uploadParam.playbackFormLabel;
    case /* DestinationGoogleSheet */10 :
        return "Destination Google Sheet";
    case /* PaginateOption */11 :
        return "Paginate and load items";
    case /* LoginToWebsite */12 :
        return "Replay on " + (URLUtils$SmartcutsMacros.extractDomainName(column._0) + " as user");
    
  }
}

function maybeDataValidation(userCredentials, column) {
  switch (column.TAG | 0) {
    case /* SelectInputOption */4 :
        return {
                condition: GoogleApis__Sheets__Schema$SmartcutsMacros.BooleanCondition.make("ONE_OF_LIST", Belt_Array.map(column.selectInputParam.originalLabeledValue.value.options, (function (opt) {
                            return {
                                    userEnteredValue: textForRadioOrSelectOption(opt)
                                  };
                          })), undefined),
                showCustomUi: true,
                strict: true
              };
    case /* LoginToWebsite */12 :
        var hostname = column._0;
        var options = Belt_Array.map(Belt_Array.keep(userCredentials, (function (userCredential) {
                    return userCredential._0.hostname === hostname;
                  })), (function (userCredential) {
                if (userCredential.TAG === /* PasswordCredential */0) {
                  var match = userCredential._0;
                  return "" + match.username + " (" + match.id + ")";
                }
                var match$1 = userCredential._0;
                var friendlyName = match$1.username + (" OAuthed via " + OAuthProvider$SmartcutsMacros.stringify(match$1.oauthProvider));
                return "" + friendlyName + " (" + match$1.id + ")";
              }));
        return {
                condition: GoogleApis__Sheets__Schema$SmartcutsMacros.BooleanCondition.make("ONE_OF_LIST", Belt_Array.map(options, (function (value) {
                            return {
                                    userEnteredValue: value
                                  };
                          })), undefined),
                showCustomUi: true,
                strict: true
              };
    default:
      return ;
  }
}

var Column = {
  header: header,
  maybeDataValidation: maybeDataValidation
};

function columnsFromSmartcutParam(param) {
  var param$1 = param.param;
  var otherCommandIndexes = param.otherCommandIndexes;
  var firstCommandIndex = param.firstCommandIndex;
  switch (param$1.TAG | 0) {
    case /* AddTextInputParam */0 :
        return [{
                  TAG: /* AddTextOption */1,
                  firstCommandIndex: firstCommandIndex,
                  otherCommandIndexes: otherCommandIndexes,
                  addTextInputParam: param$1._0
                }];
    case /* InnerTextParam */1 :
        return [{
                  TAG: /* InnerTextOption */2,
                  firstCommandIndex: firstCommandIndex,
                  otherCommandIndexes: otherCommandIndexes,
                  innerTextParam: param$1._0
                }];
    case /* CheckboxParam */2 :
        return [{
                  TAG: /* CheckboxOption */3,
                  firstCommandIndex: firstCommandIndex,
                  otherCommandIndexes: otherCommandIndexes,
                  checkboxParam: param$1._0
                }];
    case /* SelectInputParam */3 :
        return [{
                  TAG: /* SelectInputOption */4,
                  firstCommandIndex: firstCommandIndex,
                  otherCommandIndexes: otherCommandIndexes,
                  selectInputParam: param$1._0
                }];
    case /* RadioInputParam */4 :
        return [{
                  TAG: /* RadioInputOption */5,
                  firstCommandIndex: firstCommandIndex,
                  otherCommandIndexes: otherCommandIndexes,
                  radioInputParam: param$1._0
                }];
    case /* URLParam */5 :
        return [{
                  TAG: /* OpenWebsiteURL */0,
                  firstCommandIndex: firstCommandIndex,
                  otherCommandIndexes: otherCommandIndexes,
                  urlParam: param$1._0
                }];
    case /* DownloadParam */6 :
        return [{
                  TAG: /* DownloadOption */6,
                  firstCommandIndex: firstCommandIndex,
                  otherCommandIndexes: otherCommandIndexes,
                  downloadParam: param$1._0
                }];
    case /* GoogleSheetsParam */7 :
        return [{
                  TAG: /* GoogleSheetsOption */7,
                  firstCommandIndex: firstCommandIndex,
                  otherCommandIndexes: otherCommandIndexes,
                  googleSheetsParam: param$1._0
                }];
    case /* LoopParam */8 :
        return [{
                  TAG: /* LoopOption */8,
                  firstCommandIndex: firstCommandIndex,
                  otherCommandIndexes: otherCommandIndexes,
                  loopParam: param$1._0
                }];
    case /* UploadParam */9 :
        return [{
                  TAG: /* UploadOption */9,
                  firstCommandIndex: firstCommandIndex,
                  otherCommandIndexes: otherCommandIndexes,
                  uploadParam: param$1._0
                }];
    case /* WithElementGroupsParam */10 :
        var withElementGroupsParam = param$1._0;
        return Belt_Array.concat(Belt_Array.mapWithIndex(withElementGroupsParam.actions, (function (actionIndex, action) {
                          return {
                                  TAG: /* DestinationGoogleSheet */10,
                                  firstCommandIndex: firstCommandIndex,
                                  otherCommandIndexes: otherCommandIndexes,
                                  withElementGroupsParam: withElementGroupsParam,
                                  actionIndex: actionIndex
                                };
                        })), [{
                      TAG: /* PaginateOption */11,
                      firstCommandIndex: firstCommandIndex,
                      otherCommandIndexes: otherCommandIndexes,
                      withElementGroupsParam: withElementGroupsParam
                    }]);
    
  }
}

function transformRowsToPlaybackValues(fromRowOpt, smartcutParams, loginSmartcuts, userCredentials, rows) {
  var fromRow = fromRowOpt !== undefined ? fromRowOpt : 1;
  var arg = Belt_Array.sliceToEnd(rows, fromRow);
  var param = function (rowIndex, rowData) {
    var arg = rowData.values;
    var values = (function (param) {
          return OptionUtils$SmartcutsMacros.getExn(param, arg);
        })("Expected row to have values");
    if (Belt_Array.every(values, (function (cellData) {
              var match = cellData.effectiveValue;
              if (match === undefined) {
                return true;
              }
              var match$1 = match.stringValue;
              if (match$1 !== undefined && match$1 !== "") {
                return false;
              } else {
                return true;
              }
            }))) {
      return ;
    }
    var loginToWebsites = Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.getHostnamesWithAtLeastOneLoginSmartcut, loginSmartcuts);
    var columns = Belt_Array.concat(ArrayUtils$SmartcutsMacros.flatMap(columnsFromSmartcutParam, smartcutParams), Belt_Array.map(loginToWebsites, (function (hostname) {
                return {
                        TAG: /* LoginToWebsite */12,
                        _0: hostname
                      };
              })));
    return Belt_Array.reduceWithIndex(Belt_Array.zip(columns, values), PlaybackValues$SmartcutsMacros.init(undefined), (function (playbackValues, param, columnIndex) {
                  var cell = param[1];
                  var column = param[0];
                  switch (column.TAG | 0) {
                    case /* OpenWebsiteURL */0 :
                        var match = column.urlParam;
                        var originalUrl = match.originalUrl;
                        var value = cell.formattedValue;
                        var url = value !== undefined && value !== "" ? value : originalUrl;
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, {
                                      TAG: /* URLParamValue */5,
                                      _0: {
                                        url: url,
                                        urlCommandType: match.urlCommandType
                                      }
                                    }),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* AddTextOption */1 :
                        var match$1 = column.addTextInputParam;
                        var originalLabeledAddText = match$1.originalLabeledAddText;
                        var text = cell.formattedValue;
                        var labeledAddTextInput = text !== undefined && text !== "" ? ({
                              label: originalLabeledAddText.label,
                              addText: {
                                TAG: /* StaticText */0,
                                _0: text
                              }
                            }) : originalLabeledAddText;
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, {
                                      TAG: /* AddTextInputParamValue */0,
                                      _0: {
                                        targetLocator: match$1.targetLocator,
                                        labeledAddTextInput: labeledAddTextInput
                                      }
                                    }),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* InnerTextOption */2 :
                        var defaultValue = column.innerTextParam.defaultValue;
                        var text$1 = cell.formattedValue;
                        var innerText = text$1 !== undefined && text$1 !== "" ? text$1 : defaultValue;
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, {
                                      TAG: /* InnerTextParamValue */1,
                                      _0: innerText
                                    }),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* CheckboxOption */3 :
                        var arg = cell.formattedValue;
                        console.warn("Ignoring value = " + ((function (param) {
                                    return OptionUtils$SmartcutsMacros.stringify(param, arg);
                                  })(function (value) {
                                    return value;
                                  }) + (" from (row=" + (String((fromRow + rowIndex | 0) + 1 | 0) + ("column=" + (String(columnIndex + 1 | 0) + ") because the param type is not supported: CheckboxParam"))))));
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, PlaybackParamValue$SmartcutsMacros.fromSmartcutParam({
                                          TAG: /* CheckboxParam */2,
                                          _0: column.checkboxParam
                                        })),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* SelectInputOption */4 :
                        var match$2 = column.selectInputParam;
                        var match$3 = match$2.originalLabeledValue;
                        var options = match$3.value.options;
                        var arg$1 = ArrayUtils$SmartcutsMacros.firstMatchi((function (opt) {
                                return Caml_obj.caml_equal(cell.formattedValue, textForRadioOrSelectOption(opt));
                              }), options);
                        var match$4 = (function (param) {
                              return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                            })("Expect to get matching option");
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, {
                                      TAG: /* SelectInputParamValue */3,
                                      _0: {
                                        targetLocator: match$2.targetLocator,
                                        labeledValue: {
                                          label: match$3.label,
                                          value: {
                                            options: options,
                                            selectedIndex: match$4[1]
                                          }
                                        }
                                      }
                                    }),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* RadioInputOption */5 :
                        var arg$2 = cell.formattedValue;
                        console.warn("Ignoring value = " + ((function (param) {
                                    return OptionUtils$SmartcutsMacros.stringify(param, arg$2);
                                  })(function (value) {
                                    return value;
                                  }) + (" from (row=" + (String((fromRow + rowIndex | 0) + 1 | 0) + ("column=" + (String(columnIndex + 1 | 0) + ") because the param type is not supported: RadioInnputParam"))))));
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, PlaybackParamValue$SmartcutsMacros.fromSmartcutParam({
                                          TAG: /* RadioInputParam */4,
                                          _0: column.radioInputParam
                                        })),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* DownloadOption */6 :
                        var text$2 = cell.formattedValue;
                        var playbackParamValue = text$2 !== undefined && text$2 !== "" ? ({
                              TAG: /* DownloadParamValue */6,
                              _0: /* CustomFilename */{
                                _0: text$2
                              }
                            }) : ({
                              TAG: /* DownloadParamValue */6,
                              _0: /* DefaultFilename */0
                            });
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, playbackParamValue),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* GoogleSheetsOption */7 :
                        var match$5 = column.googleSheetsParam;
                        var firstCommandIndex = column.firstCommandIndex;
                        if (match$5.TAG === /* UpdateCellParam */0) {
                          var match$6 = match$5._0;
                          var toValue = match$6.cellUpdate.toValue;
                          var text$3 = cell.formattedValue;
                          var valueToUpdateCellToForPlayback = text$3 !== undefined && text$3 !== "" ? ({
                                TAG: /* Value */1,
                                _0: {
                                  TAG: /* StaticText */0,
                                  _0: text$3
                                }
                              }) : toValue;
                          return {
                                  smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex, {
                                        TAG: /* GoogleSheetsParamValue */7,
                                        _0: {
                                          TAG: /* UpdateCellParamValue */0,
                                          _0: {
                                            spreadsheetId: match$6.spreadsheetId,
                                            sheetName: match$6.sheetName,
                                            keyColumnIndex: match$6.keyColumnIndex,
                                            keyColumnValue: match$6.keyColumnValue,
                                            colNames: match$6.colNames,
                                            updatedColIndex: match$6.updatedColIndex,
                                            cellUpdate: valueToUpdateCellToForPlayback
                                          }
                                        }
                                      }),
                                  credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                                };
                        }
                        var match$7 = match$5._0;
                        var keyColumnValue = match$7.keyColumnValue;
                        var keyColumnIndex = match$7.keyColumnIndex;
                        var text$4 = cell.formattedValue;
                        var keyColumnValueForPlayback = text$4 !== undefined && text$4 !== "" ? ({
                              TAG: /* Value */1,
                              _0: {
                                TAG: /* StaticText */0,
                                _0: text$4
                              }
                            }) : keyColumnValue;
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex, {
                                      TAG: /* GoogleSheetsParamValue */7,
                                      _0: {
                                        TAG: /* UpsertRowParamValue */1,
                                        _0: {
                                          spreadsheetId: match$7.spreadsheetId,
                                          sheetName: match$7.sheetName,
                                          keyColumnIndex: keyColumnIndex,
                                          keyColumnValue: keyColumnValueForPlayback,
                                          colNames: match$7.colNames,
                                          rowData: ArrayUtils$SmartcutsMacros.setWithoutFill(keyColumnIndex, keyColumnValueForPlayback, match$7.rowData)
                                        }
                                      }
                                    }),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* LoopOption */8 :
                        var arg$3 = cell.formattedValue;
                        console.warn("Ignoring value = " + ((function (param) {
                                    return OptionUtils$SmartcutsMacros.stringify(param, arg$3);
                                  })(function (value) {
                                    return value;
                                  }) + (" from (row=" + (String((fromRow + rowIndex | 0) + 1 | 0) + ("column=" + (String(columnIndex + 1 | 0) + ") because the param type is not supported: LoopParam"))))));
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, PlaybackParamValue$SmartcutsMacros.fromSmartcutParam({
                                          TAG: /* LoopParam */8,
                                          _0: column.loopParam
                                        })),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* UploadOption */9 :
                        var arg$4 = cell.formattedValue;
                        var filePath = (function (param) {
                              return OptionUtils$SmartcutsMacros.getExn(param, arg$4);
                            })("Expect file path in cell");
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, column.firstCommandIndex, {
                                      TAG: /* UploadParamValue */9,
                                      _0: {
                                        TAG: /* FileReference */1,
                                        _0: {
                                          TAG: /* StaticText */0,
                                          _0: filePath
                                        }
                                      }
                                    }),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* DestinationGoogleSheet */10 :
                        var actionIndex = column.actionIndex;
                        var withElementGroupsParam = column.withElementGroupsParam;
                        var firstCommandIndex$1 = column.firstCommandIndex;
                        var arg$5 = Belt_Array.get(withElementGroupsParam.actions, actionIndex);
                        var match$8 = (function (param) {
                              return OptionUtils$SmartcutsMacros.getExn(param, arg$5);
                            })("Expect to get action by index");
                        var googleSheet = match$8._0;
                        var recordedGoogleSheet;
                        recordedGoogleSheet = googleSheet.TAG === /* ExistingGoogleSheet */0 ? googleSheet._0 : undefined;
                        var arg$6 = Belt_Option.flatMap(cell.formattedValue, (function (spreadsheetUrl) {
                                return Belt_Option.map(GoogleSheetHelpers$SmartcutsMacros.maybeGetSpreadsheetIdFromUrl(spreadsheetUrl), (function (spreadsheetId) {
                                              return {
                                                      spreadsheetId: spreadsheetId,
                                                      spreadsheetName: WithElementGroupsCommand$SmartcutsMacros.unknownSpreadsheet,
                                                      spreadsheetUrl: spreadsheetUrl,
                                                      worksheetName: "Sheet1"
                                                    };
                                            }));
                              }));
                        var arg$7 = (function (param) {
                              return OptionUtils$SmartcutsMacros.orElse(param, arg$6);
                            })(recordedGoogleSheet);
                        var googleSheet$1 = (function (param) {
                              return OptionUtils$SmartcutsMacros.getExn(param, arg$7);
                            })("Expect to get destination sheet");
                        var arg$8 = Belt_Option.flatMap(Belt_MapInt.get(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex$1), (function (paramValue) {
                                if (paramValue.TAG === /* WithElementGroupsParamValue */10) {
                                  return paramValue._0;
                                }
                                console.warn("Expect WithElementGroupsParamValue");
                                
                              }));
                        var withElementGroupsParamValue = (function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg$8);
                            })(WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(withElementGroupsParam));
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex$1, {
                                      TAG: /* WithElementGroupsParamValue */10,
                                      _0: {
                                        actions: ArrayUtils$SmartcutsMacros.replaceAtIndex(withElementGroupsParamValue.actions, actionIndex, /* ExportTo */{
                                              _0: {
                                                TAG: /* ExistingGoogleSheet */0,
                                                _0: googleSheet$1
                                              }
                                            }),
                                        paginateOptions: withElementGroupsParamValue.paginateOptions
                                      }
                                    }),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* PaginateOption */11 :
                        var firstCommandIndex$2 = column.firstCommandIndex;
                        var value$1 = cell.formattedValue;
                        var loadItems = value$1 !== undefined ? /* NumberOfItems */({
                              _0: Caml_format.caml_int_of_string(value$1)
                            }) : /* ItemsOnFirstPage */0;
                        var arg$9 = Belt_Option.flatMap(Belt_MapInt.get(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex$2), (function (paramValue) {
                                if (paramValue.TAG === /* WithElementGroupsParamValue */10) {
                                  return paramValue._0;
                                }
                                console.warn("Expect WithElementGroupsParamValue");
                                
                              }));
                        var withElementGroupsParamValue$1 = (function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg$9);
                            })(WithElementGroupsCommand$SmartcutsMacros.PlaybackParamValue.fromParamDescriptor(column.withElementGroupsParam));
                        return {
                                smartcutParamValuesByCommandIndex: Belt_MapInt.set(playbackValues.smartcutParamValuesByCommandIndex, firstCommandIndex$2, {
                                      TAG: /* WithElementGroupsParamValue */10,
                                      _0: {
                                        actions: withElementGroupsParamValue$1.actions,
                                        paginateOptions: {
                                          paginateMethod: withElementGroupsParamValue$1.paginateOptions.paginateMethod,
                                          loadItems: loadItems
                                        }
                                      }
                                    }),
                                credentialDbIdsByHostname: playbackValues.credentialDbIdsByHostname
                              };
                    case /* LoginToWebsite */12 :
                        var credentialIdRe = new RegExp("\\s\\((.+)\\)$");
                        var maybeCredential = Belt_Option.flatMap(Belt_Option.flatMap(cell.formattedValue, (function (value) {
                                    return Belt_Option.flatMap(Belt_Option.flatMap(Caml_option.null_to_opt(credentialIdRe.exec(value)), (function (result) {
                                                      return Belt_Array.get(result, 1);
                                                    })), (function (prim) {
                                                  if (prim == null) {
                                                    return ;
                                                  } else {
                                                    return Caml_option.some(prim);
                                                  }
                                                }));
                                  })), (function (credentialId) {
                                return ArrayUtils$SmartcutsMacros.firstMatch((function (credential) {
                                              return UserCredential$SmartcutsMacros.WithReEntryStatusAndOAuthProviderCredential.dbIdGet(credential) === credentialId;
                                            }), userCredentials);
                              }));
                        if (maybeCredential !== undefined) {
                          return {
                                  smartcutParamValuesByCommandIndex: playbackValues.smartcutParamValuesByCommandIndex,
                                  credentialDbIdsByHostname: Belt_MapString.set(playbackValues.credentialDbIdsByHostname, column._0, UserCredential$SmartcutsMacros.WithReEntryStatusAndOAuthProviderCredential.dbIdGet(maybeCredential))
                                };
                        } else {
                          console.warn("Did not find matching credential for cellvalue ", cell.formattedValue);
                          return playbackValues;
                        }
                    
                  }
                }));
  };
  return ArrayUtils$SmartcutsMacros.filterMapi(param, arg);
}

exports.Row = Row;
exports.makeWorksheet = makeWorksheet;
exports.askBgToCreateSheet = askBgToCreateSheet;
exports.askExtensionToCreateAnySpreadsheetsForInstall = askExtensionToCreateAnySpreadsheetsForInstall;
exports.textForRadioOrSelectOption = textForRadioOrSelectOption;
exports.Column = Column;
exports.columnsFromSmartcutParam = columnsFromSmartcutParam;
exports.transformRowsToPlaybackValues = transformRowsToPlaybackValues;
/* URLUtils-SmartcutsMacros Not a pure module */
